import { render, staticRenderFns } from "./DirectDebitIcon.vue?vue&type=template&id=79eda39b&"
import script from "./DirectDebitIcon.vue?vue&type=script&lang=js&"
export * from "./DirectDebitIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports